


















































































































import Table1 from '../../views/data/tables/Table1.vue'
import Table2 from '../../views/data/tables/Table2.vue'
import Table3 from '../../views/data/tables/Table3.vue'
import Table4 from '../../views/data/tables/Table4.vue'
import Table5 from '../../views/data/tables/Table5.vue'
import Table6 from '../../views/data/tables/Table6.vue'
import Table7 from '../../views/data/tables/Table7.vue'
import Table8 from '../../views/data/tables/Table8.vue'
import Table9 from '../../views/data/tables/Table9.vue'
import Table10 from '../../views/data/tables/Table10.vue'
import Table11 from '../../views/data/tables/Table11.vue'
import Table12 from '../../views/data/tables/Table12.vue'
import Table13 from '../../views/data/tables/Table13.vue'
import Table14 from '../../views/data/tables/Table14.vue'
import Table15 from '../../views/data/tables/Table15.vue'
import Table16 from '../../views/data/tables/Table16.vue'
import Table17 from '../../views/data/tables/Table17.vue'
import Formulas from '../../views/data/tables/Formulas.vue'
export default {
  data () {
    return {
      table1Active: false,
      table2Active: false,
      table3Active: false,
      table4Active: false,
      table5Active: false,
      table6Active: false,
      table7Active: false,
      table8Active: false,
      table9Active: false,
      table10Active: false,
      table11Active: false,
      table12Active: false,
      table13Active: false,
      table14Active: false,
      table15Active: false,
      table16Active: false,
      table17Active: false,
      formulasActive: false
    }
  },

  components: {
    Table1, Table2, Table3, Table4, Table5, Table6, Table7, Table8, Table9, Table10, Table11, Table12, Table13, Table14, Table15, Table16, Table17, Formulas
  }
}
